import { Component, OnDestroy, OnInit, inject, input, output } from "@angular/core";
import { MessageTypes } from "libs/messages/src/lib/models/message.model";
import { MessageTypeIcons } from "libs/messages/src/lib/services/message-type-icons.lib.service";
import { Editor, toHTML, toDoc, Toolbar, NgxEditorModule } from 'ngx-editor';
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { FormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { Slice } from "prosemirror-model";
import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";

@Component({
	selector: "lib-comment",
	templateUrl: "./comment.component.html",
	styleUrls: ["./_comment.component.scss"],
	imports: [FaIconComponent, NgxEditorModule, FormsModule, TranslatePipe],
})
export class CommentComponent implements OnInit, OnDestroy {
	private config = inject<AppConfig>(APP_CONFIG_TOKEN);

	readonly showTypeHeader = input<boolean>(true);
	readonly type = input<MessageTypes>(MessageTypes.Note);
	readonly htmlContent = input("");
	readonly valueChanges = output<string>();

	maxLength = 1024;
	MessageTypes = MessageTypes;
	MessageTypeIcons = MessageTypeIcons;
	editor: Editor;
	toolbar: Toolbar = [
		['bold', 'italic'],
		['underline'],
		['ordered_list', 'bullet_list'],
		['link'],
		['undo', 'redo'],
	  ];


	ngOnInit() {
		this.editor = new Editor();
		this.editor.valueChanges.subscribe((value) => {
			let sanitizedHtml = toHTML(value);
			//avoid pasting images/other files in customer frontend
			if( this.config.app === "tm2"){
				sanitizedHtml = toHTML(value).replace(/<img(.*?)>/g, ' ');
			}
			this.valueChanges.emit(sanitizedHtml);
		})
	}

	insertHtmlAtCursor(html: string): void {
		if (!this.editor?.view) {
			return;
		}

		const view = this.editor.view;
		const schema = view.state.schema;
		const docJson = toDoc(html, schema);
		const node = schema.nodeFromJSON(docJson);

		const { state } = view;
		const tr = state.tr.replaceSelection(new Slice(node.content, 0, 0));
		view.dispatch(tr);
	}

	focusEditor(): void {
		this.editor?.view?.focus();
	}

	ngOnDestroy(): void {
		this.editor.destroy();
	}
}
